import {NavManager} from 'common/contexts/nav-manager/types';

export class SimpleNavManager implements NavManager {
  navigate(url: string) {
    window.location.href = url;
  }

  updateProps() {}

  getSpaNavCount() {
    return 0;
  }
}
